import { makeStyles } from "@material-ui/styles";

const drawerWidth = 320;

export default makeStyles(theme => ({
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 40,
    [theme.breakpoints.down("sm")]: {
      width: drawerWidth,
    },
  },
  toolbar: {
    ...theme.mixins.toolbar,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  // Lay the drawer out as a column so the admin list can be pinned to the
  // bottom. Works the same for the permanent (desktop) and temporary (mobile)
  // Drawer variants, since both fill the viewport height.
  drawerPaper: {
    display: "flex",
    flexDirection: "column",
  },
  sidebarList: {
    overflowY: "auto",
    // Clip the full-width items horizontally so the narrow collapsed drawer
    // doesn't grow a horizontal scrollbar (this list is its own scroll
    // container, so it no longer inherits the paper's overflowX: hidden).
    overflowX: "hidden",
  },
  // Pushed to the bottom of the column; the top list takes the remaining space.
  bottomList: {
    marginTop: "auto",
    overflowX: "hidden",
  },
  mobileBackButton: {
    marginTop: theme.spacing(0.5),
    marginLeft: 18,
    [theme.breakpoints.only("sm")]: {
      marginTop: theme.spacing(0.625),
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  // Mobile-only block at the top of the drawer holding the active-group picker
  // and language switcher (these live in the header on desktop).
  mobileExtras: {
    padding: theme.spacing(1, 2, 1.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  mobileGroupRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1.5),
  },
  mobileGroupLabel: {
    marginRight: theme.spacing(1),
    fontSize: 13,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.5,
    color: theme.palette.text.secondary,
    whiteSpace: "nowrap",
  },
  mobileGroupSelect: {
    flex: 1,
    fontSize: 16,
    fontWeight: 500,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    "& .MuiSelect-select": {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
  },
  joinGroupItem: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontWeight: 600,
    justifyContent: "center",
    "&:hover": {
      backgroundColor: theme.palette.primary.light,
    },
  },
  mobileLangSwitcher: {
    display: "flex",
    alignItems: "center",
  },
  mobileLangFlag: {
    width: 28,
    height: "auto",
    cursor: "pointer",
    borderRadius: 2,
    opacity: 0.4,
    transition: theme.transitions.create("opacity"),
    marginRight: theme.spacing(1),
    "&:hover": {
      opacity: 0.8,
    },
  },
  mobileLangFlagActive: {
    opacity: 1,
    cursor: "default",
    outline: `2px solid ${theme.palette.primary.main}`,
    "&:hover": {
      opacity: 1,
    },
  },
}));
